import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'
import type { ApiResponse, PaginatedResponse, Pagination } from '@/app/types'
import api from '@/app/services/apiNir.ts'
import type { AxiosResponse } from 'axios'

export interface RegistrationStatus {
  id: string
  institutionId: string | null
  status: string
  description: string
  createdAt: string
}

export const useRegistrationStatusesStore = defineStore('registration-statuses', () => {
  const registrationStatuses: Ref<RegistrationStatus[] | undefined> = ref()
  const pagination: Ref<Pagination | undefined> = ref()

  const fetchRegistrationStatuses = async (page: number, limit: number, institutionId?: string) => {
    let path = `/v1/registry/registration/statuses?page=${page}&limit=${limit}`
    if (institutionId) path += `&institutionId=${institutionId}`
    return api.get(path)
      .then((response: AxiosResponse<ApiResponse<PaginatedResponse<RegistrationStatus>>>) => {
        registrationStatuses.value = response.data.data.content
        pagination.value = response.data.data.pagination
      })
  }

  const createRegistrationStatus = async (payload: { institutionId: string; status: string; description: string }) => {
    return api.post('/v1/registry/registration/statuses', payload)
  }

  const updateRegistrationStatus = async (payload: { id: string; status: string; description: string }) => {
    return api.put('/v1/registry/registration/statuses', payload)
  }

  return {
    registrationStatuses,
    pagination,
    fetchRegistrationStatuses,
    createRegistrationStatus,
    updateRegistrationStatus,
  }
})
